export function needsPatientReportDetails(patient) {
  return Boolean(patient && (!patient.alias?.trim() || !patient.birthDate));
}

export function validatePatientReportDetails({ alias, birthDate }, today) {
  const normalizedAlias = alias?.trim().replace(/\s+/g, " ") || "";
  if (!normalizedAlias) return { error: "Введите псевдоним для отчёта" };
  if (!birthDate) return { error: "Укажите дату рождения" };
  const date = new Date(`${birthDate}T00:00:00Z`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(birthDate) || Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== birthDate) {
    return { error: "Укажите корректную дату рождения" };
  }
  if (today && birthDate > today) return { error: "Дата рождения не может быть в будущем" };
  return { data: { alias: normalizedAlias, birthDate } };
}
